import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import "../Forms/css/register.css";

const token = localStorage.getItem('authToken');

class EditPackages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addDeals: '',
      title: '',
      description: '',
      price: '',
      price: '',
      startDate: '',
      endDate: '',
      submissionStatus: null,
      id: null,
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
    } else {
      console.error("No match or id found in props");
    }
  }

  fetchData = async (id) => {
    console.log("Fetch data called with id:", id);
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/package/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const packageData = response?.data;
      console.log("Fetch data response:", packageData);
      if (packageData) {
        this.setState({
          title: packageData?.title || '',
          description: packageData?.description || '',
          addDeals: packageData?.addDeals || '',
          price: packageData?.price || '',
          startDate: packageData?.startDate ? new Date(packageData.startDate).toISOString().substr(0, 10) : '', // Format date
          endDate: packageData?.endDate ? new Date(packageData.endDate).toISOString().substr(0, 10) : '', // Format date
        });
      } else {
        console.error("No package data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id, title, description, addDeals, price, startDate, endDate } = this.state;

    const jsonData = { title, description, price, startDate, endDate };

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      };

      const response = await axios.put(`https://brand.aasmo.in/api/admin/package/${id}`, jsonData, config);

      console.log('Response:', response);

      if (response && response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        console.log('Form submitted successfully');
        setTimeout(() => {
          this.props.history.push('/list-packages');
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
      }
    } catch (error) {
      console.error('Error submitting form:', error);

      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          console.error('Bad request error:', data);
        } else if (status === 401) {
          console.error('Unauthorized error, please log in again.');
        } else {
          console.error('Error response:', error.response);
        }
      } else {
        console.error('Network or other error:', error);
      }
    }
  };

  render() {
    const { title, description, price, addDeals,startDate, endDate, submissionStatus } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Edit Packages</h2>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={title}
                      onChange={this.handleChange}
                      placeholder="Package Title"
                    />
                  </div>
                  <div className="form-group">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={description}
                      onChange={this.handleChange}
                      placeholder="Package Description"
                    />
                  </div>
                  <div className="form-group">
                    <label>Price</label>
                    <input
                      type="number"
                      className="form-control"
                      name="price"
                      value={price}
                      onChange={this.handleChange}
                      placeholder="Purchase Price"
                    />
                  </div>
                  <div className="form-group">
                    <label>Add Deals</label>
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      name="addDeals"
                      value={addDeals}
                      onChange={this.handleChange}
                      placeholder="Package Add Deals"
                    />
                  </div>
                  <div className="form-group">
                    <label>Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="startDate"
                      value={startDate}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Expiry Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="endDate"
                      value={endDate}
                      onChange={this.handleChange}
                    />
                  </div>
                  {submissionStatus === 'success' && (
                    <div className="alert alert-success" role="alert">
                      Form submitted successfully!
                    </div>
                  )}
                  <button
                    className="btn btn-primary"
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default withRouter(connect(mapStateToProps)(EditPackages));
